export default __webpack_public_path__ + "static/building-fe9361e7d43e7502a4ca1b4cbb1e410d.svg";